import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import SectionTitle from "./SectionTitle"


// Section - used in the Layout
const Section = ({ children, sidebar_heading, color, b_top, b_bottom, my, content_px, content_pt, content_pb, content_px_sm, content_pt_sm, content_pb_sm, content_title, content_title_left }) => {
  return (
    <SectionContainer my={my} b_top={b_top} b_bottom={b_bottom}>
      <Sidebar sidebar_heading={sidebar_heading}>
        <Heading>
          {sidebar_heading}
        </Heading>
      </Sidebar>
      <Content color={color} px={content_px} pt={content_pt} pb={content_pb} px_sm={content_px_sm} pt_sm={content_pt_sm} pb_sm={content_pb_sm}>
        { content_title ? <SectionTitle title={content_title} left={content_title_left} /> : ''}
        {children}
      </Content>
    </SectionContainer>
  )
}


// --------------- Component Information --------------- //


Section.propTypes = {
  children: PropTypes.node,
  sidebar_heading: PropTypes.string,
  color: PropTypes.string,
  b_top: PropTypes.bool,
  b_bottom: PropTypes.bool,
  my: PropTypes.number,
  content_px: PropTypes.number,
  content_pt: PropTypes.number,
  content_pb: PropTypes.number,
  content_px_sm: PropTypes.number,
  content_pt_sm: PropTypes.number,
  content_pb_sm: PropTypes.number,
  content_title: PropTypes.string,
  content_title_left: PropTypes.bool,
}


Section.defaultProps = {
  color: 'White',
  b_top: false,
  b_bottom: false,
  my: 0,
  content_pt: 0,
  content_px: 6,
  content_pb: 6,
  content_pt_sm: 0,
  content_px_sm: 3,
  content_pb_sm: 6,
  content_title_left: false,
}


// --------------- Styled Components --------------- //


// Section html tag - Main container of the Section
const SectionContainer = styled.section`
  
  // Spacing
  margin: ${({ my }) => `var(--spacer-${my}) 0;`};
  padding: 0;
  
  // Sizing
  width: 100%;
  
  // Positioning
  position: relative;
  
  // Grid
  display: grid;
  grid-template-columns: 5fr 95fr;
  grid-auto-rows: auto;
  
  // Border
  ${props => props.b_bottom && "border-bottom: 1px solid var(--borderColor);"}
  ${props => props.b_top && "border-top: 1px solid var(--borderColor);"}
  border-radius: 0;
  
  // Medium devices and below - no sidebar
  @media only screen and (max-width : 768px) {
    grid-template-columns: 1fr;
  }

`


// Sidebar of the Section
const Sidebar = styled.div`
  
  // Spacing
  margin: 0;
  padding: ${props => props.sidebar_heading ? 'var(--spacer-6)' : '0' } 0;
  
  // Flexbox
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  
  // Border
  border-right: 1px solid var(--borderColor);
  border-radius: 0;
  
  // Color
  background-color: var(--primaryWhite);
  
  // Medium devices and below
  @media only screen and (max-width : 768px) {
    display: none;
  }
  
`


// Content body - where all the content resides - component children goes inside this
const Content = styled.div`
  
  // Color
  background-color: ${({ color }) => `var(--primary${color});`};
  
  // Spacing
  margin: 0;
  padding: ${({ pt, pb, px }) => `var(--spacer-${pt}) var(--spacer-${px}) var(--spacer-${pb}) var(--spacer-${px});`};
    
  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-3);
  line-height: 1.5;
  text-align: justify;
    
  // Color
  color: var(--textBlack);
  
  // Mobile phones and below
  @media only screen and (max-width : 544px) {
    padding: ${({ pt_sm, pb_sm, px_sm }) => `var(--spacer-${pt_sm}) var(--spacer-${px_sm}) var(--spacer-${pb_sm}) var(--spacer-${px_sm});`};
  }
  
`


// Sidebar heading
const Heading = styled.h1`
  
  // Spacing
  margin: 0;
  padding: 0;
  
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-5);
  line-height: 1.5;
  text-align: center;
  writing-mode: vertical-rl;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  // Color
  color: var(--textRed);
  
`


// ********** Exports ********** //


export default Section


// ********** EOF ********** //
